import React from 'react';
import { injectIntl } from 'react-intl';
import GeneralBlockSpecificationStep from './GeneralBlockSpecificationStep';
import ActivityArchitecture from './ActivityArchitecture';
import { isValidBlock } from '../common_components/bmc/bmc_functions';
import { inject, observer } from 'mobx-react';
import {
  Row,
  Col,
  Dropdown,
  MenuItem
} from 'react-bootstrap';
import { isLeanBlock } from './functions';
import { SECTIONS } from './constantsTooltips';
import BmcBlockIcon from '../common_components/bmc/BmcBlockIcon';
import LeanBlockIcon from './LeanBlockIcon';
import Stages from '../common_components/bmc/Stages';
import ActivityArchitectureMobile from './mobile/ActivityArchitectureMobile';

@injectIntl
@inject('rootStore')
@observer
export default class NewActivity extends React.Component {
  constructor(props) {
    super(props);
    this.handleTemplateSelect = this.handleTemplateSelect.bind(this);
    this.handleStageClick = this.handleStageClick.bind(this);
    this.reinitActivity = this.reinitActivity.bind(this);
  }

  render() {
    const step = this.props.match.params.step;
    const { intl } = this.props;
    const title = intl.formatMessage({ id: 'title-' + step });
    const currentStage = this.props.rootStore.igBusinessStore.currentStage;
    let name;
    let icon;
    if (isLeanBlock(step)) {
      name = intl.formatMessage({ id: 'lean-block-' + step });
      icon = <LeanBlockIcon block={step} />;
    } else {
      name = intl.formatMessage({ id: 'IgbmcBoard-' + step });
      icon = <BmcBlockIcon block={step} />;
    }

    if (isValidBlock(step) || isLeanBlock(step)) {
      return (
        <div>
          <Row id="stages">
            <Col xs={12}>
              <Stages
                current={currentStage}
                onStageClick={this.handleStageClick}
              />
              <br />
            </Col>
          </Row>

          <Row id="stage-description" className="step-title">
            <Col xs={12}>
              <div>
                <span className="bold">
                  <span className="block-name">
                    {icon}&nbsp;{name}:&nbsp;
                  </span>
                  {title}
                </span>
              </div>
            </Col>
          </Row>

          <Row id="stage-body">
            <Col xs={12} md={4} className="pull-right" id="stage-tour-picker">
              {this.renderTemplateButton()}
              <GeneralBlockSpecificationStep
                nextPath={this.props.rootStore.nextPath()}
                prevPath={this.props.rootStore.prevPath()}
                history={this.props.history}
              />
              <br />
              <br />
            </Col>
            {window.innerWidth < 768 ? (
              <ActivityArchitectureMobile history={this.props.history} />
            ) : (
              <Col className="hidden-xs" xs={12} md={8} id="stage-tour">
                <ActivityArchitecture history={this.props.history} />
              </Col>
            )}
          </Row>
        </div>
      );
    } else {
      return (
        <div className="error-not-found">
          {intl.formatMessage({ id: 'invalid_route' })}
        </div>
      );
    }
  }

  renderTemplateButton() {
    const templates = this.props.rootStore.currentStageTemplates;
    if (templates.length != 0) {
      return (
        <Dropdown
          className="full-width"
          pullRight={false}
          id={'templates-dropdown'}
        >
          <Dropdown.Toggle noCaret={false}>
            {this.props.intl.formatMessage({ id: 'apply_template' })}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <MenuItem key={-1} onSelect={this.reinitActivity}>
              {this.props.intl.formatMessage({ id: 'none' })}
            </MenuItem>
            {templates.map((el, idx) => (
              <MenuItem
                key={idx}
                onSelect={() => this.handleTemplateSelect(el)}
              >
                {this.props.intl.formatMessage({
                  id: el.stage + '_' + el.id + '_name'
                })}
              </MenuItem>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      );
    }
    return null;
  }

  componentDidMount() {
    const { rootStore } = this.props;

    rootStore.tooltipStore.setCurrentSection(SECTIONS.new);
  }

  componentWillMount() {
    const step = this.props.match.params.step;
    if (isValidBlock(step) || isLeanBlock(step)) {
      this.props.rootStore.setCurrentBlock(step);
    }
  }
  componentWillReceiveProps(nextProps) {
    const step = nextProps.match.params.step;
    if (isValidBlock(step) || isLeanBlock(step)) {
      this.props.rootStore.setCurrentBlock(step);
    }
  }

  handleStageClick(stage) {
    this.props.rootStore.igBusinessStore.setCurrentStage(stage);
  }

  reinitActivity() {
    this.props.rootStore.activityStore.reinitEditingActivity();
  }

  handleTemplateSelect(template) {
    this.reinitActivity();
    this.props.rootStore.igBusinessStore.applyTemplate(
      template,
      this.props.intl
    );
  }
}
